/* src/app/pages/planestratamiento/formplanestratamiento/formplanestratamiento.component.scss */
:host ::ng-deep .ck-editor__editable_inline {
  min-height: 500px;
}
/*# sourceMappingURL=formplanestratamiento.component.css.map */
